import { Helmet } from "react-helmet";
import { Heading, Img, Button } from "../../components";
import CarAdsTable from "../../components/CarAdsTable";
import TestFile2AfterColumntwenty from "../../components/TestFile2AfterColumntwenty";
import TestFile2AfterRowTwo from "../../components/TestFile2AfterRowTwo";
import React, { Suspense, useState, useEffect }  from "react";
 import { useNavigate, useLocation } from "react-router-dom";
import AddNewCarModal from "../../components/modals/AddNewCarModal";



export default function RightSideMenuAdmin({
  currentUser,
  handleLogout

}) {
const location     = useLocation();
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const userName = localStorage.getItem('userName');
  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia("(max-width: 768px)").matches
  );
   const [mobileOpen, setMobileOpen] = useState(false);
// RightSideMenuDealer.jsx — רק השורה שמייצרת את המחלקות
const menuClasses = `
  right-side-menu-dealer flex w-[5%] flex-col gap-[20px] rounded-[16px] bg-black-900_03 py-7 md:w-full md:gap-[126px] sm:gap-[84px] sm:py-4
  ${isMobile ? (mobileOpen ? "open" : "closed") : "desktop"}
`;
useEffect(() => {
  const mediaQuery = window.matchMedia("(max-width: 768px)");
  const handleResize = (event) => setIsMobile(event.matches);

  mediaQuery.addEventListener("change", handleResize);
  return () => mediaQuery.removeEventListener("change", handleResize);
}, []);

useEffect(() => {
  if (isMobile) setMobileOpen(false);
}, [location.key, isMobile]);   // location.key משתנה בכל navigate, גם אם הנתיב זהה
// אפשר גם [location, isMobile] – אותו רעיון
      
  return (
    <div>
            {/* כפתור המבורגר – מוצג רק במובייל */}

    <div className={menuClasses}>
 
  <div className="flex flex-col gap-[10px] lg:gap-[10px] md:gap-[10px] sm:gap-9">
                           {isMobile && (
        <button
          className="hamburger-btn"          // נשלוט ב-CSS
          onClick={() => setMobileOpen((o) => !o)}
        >
          <Img src="/images/img_megaphone_gray_600.svg" alt="menu" />
        </button>
      )}    <div className="wrap-img-icon flex flex-col items-center justify-center gap-1.5 px-3 cursor-pointer">
                 <Img
                   src="/images/img_uuid_8da7836a_2_red_700.png"
                   alt="Uuid8da7836atwo"
                   className="img-icon h-[28px] w-full object-cover lg:h-auto md:h-auto"
                 />
                 <Heading
                   size="heading9xl"
                   as="h2"
                   className="!font-montserrat text-[25.98px] font-extrabold !text-red-a700_01 lg:text-[21px]"
                 >
                   <span className="text-secondary-primary_white">B</span>
                   <span className="text-red-a700_03">M</span>
                   <span className="text-secondary-primary_white">C</span>
                 </Heading>
               </div>
               <div className="wrap-all mx-4 flex flex-col items-center gap-6 md:mx-0 mt-5">

          {/*   <Button size="7xl" className="rounded-lg" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }}>
               <Img src="/images/img_search_secondary__primary_white.svg" />
                 </Button>*/}


                 
                 <div
                  className="wrap-icons-menu flex flex-col items-center gap-5">



    {isMobile && (
    <div
          className="tooltip flex flex-col items-center cursor-pointer"
onClick={() => navigate("/admin/cars")}        >
          <Img src="/images/img__2.svg" alt="דילר רכב" className="h-[20px]" />
          <span className="tooltip-text">רכבים</span>
        </div>
    )}


               
                  {/* <div className="tooltip flex flex-col items-center  cursor-pointer"
                   style={{padding:'13%'}}
                         onClick={() => navigate('/admin/offers')}>             
                        <Img src="/images/img__4.svg" alt="Image" className="h-[20px]" />
                <span className="tooltip-text offers">הצעות מחיר</span>

                   </div>*/}


    {/*      <div className="mt-1 tooltip flex flex-col items-center  cursor-pointer"
                   style={{padding:'13%'}}
onClick={() => navigate("/dealer-cars", { state: { defaultTab: "מודעות חדשות" } })} >                        <Img src="/images/new-ads.svg" alt="Image" className="h-[20px]" />
                <span className="tooltip-text offers">רכבים חדשים</span>

                   </div>*/}





           

                   {/*

<div
  className="p-3.5 tooltip cursor-pointer"
  onClick={() => navigate("/dealer-cars", { state: { defaultTab: "מודעות בארכיון" } })}
>
  <div className="flex flex-col items-center justify-center" style={{ width: "100%", height: "auto", aspectRatio: "1 / 1", padding: "0" }}>
<Img
  src="/images/img_layers.png"
  alt="Layers"
  className="h-[20px] w-[20px]"
/>
  </div>
  <span className="tooltip-text">ארכיון</span>
</div>*/}


                   <div
                    onClick={() => navigate("/admin/users/providers")}
                    className="cursor-pointer tooltip flex flex-col items-center  p-3.5" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }} >
                     <Img src="/images/img__5.svg" alt="Image"/>
                     <span className="tooltip-text2 mt-2">ספקים</span>  {/* עכשיו הוא בתוך ה-tooltip */}

                   </div>

                                <div
                    onClick={() => navigate("/admin/users/dealers")}
                    className="cursor-pointer tooltip flex flex-col items-center  p-3.5" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }} >
                     <Img src="/images/img__5.svg" alt="Image"/>
                     <span  className="tooltip-text2 mt-2">סוחרים</span>  {/* עכשיו הוא בתוך ה-tooltip */}

                   </div>

<div
  onClick={() => navigate("/admin/users/privates")}
  className="cursor-pointer tooltip flex flex-col items-center p-3.5"
  style={{ width: "100%", height: "auto", aspectRatio: "1 / 1", padding: "0" }}
>
  <Img src="/images/img__5.svg" alt="Image" />
  <span className="tooltip-text2 mt-2">מוכרים פרטיים</span>
</div>

                        <div
                    onClick={() => navigate("/admin/received-offers")}
                    className="cursor-pointer tooltip flex flex-col items-center  p-3.5" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }} >
                     <Img src="/images/img__4.svg" alt="Image"/>
                     <span  className="tooltip-text2 mt-2">הצעות</span>  {/* עכשיו הוא בתוך ה-tooltip */}

                   </div>

                   <div
                    onClick={() => navigate("/admin/approved-deals")}
                    className="cursor-pointer tooltip flex flex-col items-center  p-3.5" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }} >
                     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" className="shrink-0">
                       <rect x="3" y="6" width="18" height="13" rx="2" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M3 10h18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                       <path d="M7 15h4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                       <circle cx="16" cy="15" r="1.5" fill="white"/>
                       <path d="M8 6V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                     </svg>
                     <span className="tooltip-text2 mt-2">חיובים וחשבונות</span>
                   </div>

    <div
          className="tooltip flex flex-col items-center cursor-pointer"
          onClick={() => navigate("/admin/auctions")}
        >
          <Img src="/icons/white-tender.svg" alt="auctions" className="h-[20px]" />
          <span className="tooltip-text">מכרזים</span>
        </div>


                       <div
          className="tooltip flex flex-col items-center cursor-pointer p-3.5" 
          style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }}
          onClick={() => navigate("/admin/import-ads")}>
          <Img src="/images/img__2.svg" alt="דילר רכב" className="h-[20px]" />
          <span className="tooltip-text2 mt-2">יבוא רכבים</span>
        </div>
                   
                {/*   <div className="cursor-pointer tooltip flex flex-col items-center  p-3.5" style={{ width: '100%', height: 'auto', aspectRatio: '1 / 1', padding: '0' }}>
                     <Img src="/images/img_search.svg" alt="Search" />
                       <span className="tooltip-text2">הגדרות</span>  

                   </div>*/}
                 </div>
               </div>
             </div>
             <div 
  style={{
    position: 'absolute', 
    width: '100%', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center'
  }} 
  className="flex flex-col items-center md:mx-0 cursor-pointer logout-button"
>
               <div className="flex flex-col items-center justify-center " style={{ width: '100%', height: 'auto', marginBottom: '5px', padding: '0' }} >
                 <Heading
                   size="headingxl"
                   as="h3"
                   className="!font-inter text-[15px] font-semibold !text-secondary-primary_white"
                   style={{fontSize: '15px'}}
                 >
                  {currentUser?.name}
                 </Heading>
                 <Heading size="headinglg" as="h4" className="!font-inter text-[15px] font-semibold !text-yellow-800">
                   מנהל
                 </Heading>
               </div>
               <Heading
               onClick={handleLogout}
                 size="textxs"
                 as="h5"
                 className="!font-inter text-[13px] font-medium !text-white-a700_7f underline"
               >
                 התנתקות
               </Heading>

               
             </div>
             </div>

           </div>


  );
}
